<template lang="pug">
#heatmap_menu
  .row
    form.form-inline.mr-2
      .form-group.mr-3
        select.form-control-sm(v-model="selectedDate" @change="dateSelectChange")
          option(v-for='date in $store.state[this.state_name].date_for_select',:value="date.k",:key="date.k")
            | {{date.v}}
      .form-group
        vuejs-datepicker(:disabled-dates="disabledDates", :format="DatePickerFormat",:language="language", :value="$store.state[this.state_name].date_from", @selected="selectDateFrom", input-class="form-control form-control-sm", :placeholder="placeholder_date_from")
      .form-group &nbsp;~&nbsp;
      .form-group
        vuejs-datepicker(:disabled-dates="disabledDates", :format="DatePickerFormat",:language="language", :value="$store.state[this.state_name].date_to", @selected="selectDateTo", input-class="form-control form-control-sm", :placeholder="placeholder_date_to")
    div.left-line
        button.btn.btn-sm.ml-2.mr-2(:class="($store.state[this.state_name].device == 'sp') ? 'btn-primary' : 'btn-default' ", @click="setDevice('sp')")
          i.fas.fa-mobile-alt.mr-2
          | SP
        button.btn.btn-sm.ml-2.mr-2(:class="($store.state[this.state_name].device == 'pc') ? 'btn-primary' : 'btn-default' ", @click="setDevice('pc')")
          i.fas.fa-desktop.mr-2
          | PC
    div.left-line.pl-2
        | セグメント
        button.btn.btn-sm.ml-2.mr-2(:class="(event == '' && !visit_count_active) ? 'btn-primary' : 'btn-default' ", @click="resetAllSegments")
          | 指定なし
        button.btn.btn-sm.ml-2.mr-2(:class="(event == 'click') ? 'btn-primary' : 'btn-default' ", @click="setEvent('click')")
          i.fas.fa-mouse.mr-2
          | クリック
        help-tooltip(html-key='heatmapClickPv')
        button.btn.btn-sm.ml-2.mr-2(:class="(event == 'popstate') ? 'btn-primary' : 'btn-default' ", @click="setEvent('popstate')")
          i.fas.fa-undo-alt.mr-2
          | 離脱
        div.visit-count-container(style="display: inline-block; vertical-align: top; margin-left: 8px; margin-right: 8px;")
          button.btn.btn-sm(:class="(visit_count_active) ? 'btn-primary' : 'btn-default' ", @click="setVisitCount()")
            i.fas.fa-chart-line.mr-2
            | 訪問回数
          div(v-if="visit_count_active", style="margin-top: 3px;")
            a.parameter-reset-link(href="#", @click.prevent="resetVisitCount()")
              i.fas.fa-times.mr-1
              | リセット
  UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  SelectVisitCount(
      v-if="is_select_visit_count_modal"
      @close-modal="is_select_visit_count_modal = false"
      @data-from-select-visit-count="setSelectedVisitCount"
      :initial-visit-type="selected_visit_type"
    )

</template>
<script>
import Vue from "vue";

import vuejsDatepicker from "vuejs-datepicker";
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";
import SelectVisitCount from "./modals/select_visit_count.vue";
//mixins
import DateformatMixin from "../mixins/date_format.js";

export default {
  props: {
    date_from: String,
    date_to: String,
    date_yesterday_start: String,
    date_yesterday_end: String,
    date_month_start: String,
    date_last_month_start: String,
    date_last_month_end: String,
    heatmap_disabled_date_to: String,
    heatmap_available_date: String,
    has_date_restrict: Boolean,
    is_upper_master: { type: Boolean, default: false },
    heatmap_user_id: { type: Number, default: 0 },
    current_user_id: { type: Number, default: 0 },
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data() {
    var d = new Date(this.heatmap_disabled_date_to);
    d.setDate(d.getDate() - 1);
    return {
      DatePickerFormat: "yyyy-MM-dd",
      selectedDate: this.$store.state[this.state_name].date_for_select[2].k,
      language: {
        language: "Japanese",
        months: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        monthsAbbr: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        days: ["日", "月", "火", "水", "木", "金", "土"],
        rtl: false,
        ymd: "yyyy-MM-dd",
        yearSuffix: "年",
      },
      disabledDates: {
        to: d,
      },
      is_upgrade_upper_master_modal: false,
      is_select_visit_count_modal: false,
      visit_count_active: false,
      selected_visit_type: '',
    };
  },
  methods: {
    async getScroll() {
      if (this.show_scroll_heatmap) {
        await this.$store.dispatch(`${this.state_name}/getScroll`);
      }
    },
    async getClick() {
      if (this.show_click_heatmap) {
        await this.$store.dispatch(`${this.state_name}/getClick`);
      }
    },
    async getAttention() {
      if (this.show_attention_heatmap) {
        await this.$store.dispatch(`${this.state_name}/getAttention`);
      }
    },
    async selectDateFrom(date) {
      const date_from = this.formatDateToBegining(date);
      this.$store.commit(`${this.state_name}/setDateFrom`, date_from);
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async selectDateTo(date) {
      const date_to = this.formatDateToEnd(date);
      this.$store.commit(`${this.state_name}/setDateTo`, date_to);
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async dateSelectChange(e) {
      const date = e.target.value;
      if (date == "today") {
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_from);
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_to);
      } else if (date == "yesterday") {
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_yesterday_start);
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_yesterday_end);
      } else if (date == "this_month") {
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_month_start);
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_to);
      } else if (date == "last_month") {
        this.$store.commit(`${this.state_name}/setDateFrom`, this.date_last_month_start);
        this.$store.commit(`${this.state_name}/setDateTo`, this.date_last_month_end);
      }
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async setDevice(v) {
      this.$store.commit(`${this.state_name}/setDevice`, v);
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async setEvent(v) {
      this.$store.commit(`${this.state_name}/setEvent`, v)
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async setOs(v) {
      this.$store.commit(`${this.state_name}/setOs`, v);
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async setVisitCount() {
      if (this.is_upper_master) {
        this.is_select_visit_count_modal = true;
      } else {
        this.is_upgrade_upper_master_modal = true;
      }
    },
    async setSelectedVisitCount(data) {
      this.is_select_visit_count_modal = false;
      this.selected_visit_type = data.visitType;
      this.visit_count_active = data.visitType !== '';
      this.$store.commit(`${this.state_name}/setSelectedVisitType`, data.visitType);
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async resetVisitCount() {
      this.selected_visit_type = '';
      this.visit_count_active = false;
      this.$store.commit(`${this.state_name}/setSelectedVisitType`, '');
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    },
    async resetAllSegments() {
      // イベントタイプをリセット
      this.$store.commit(`${this.state_name}/setEvent`, '');

      // 訪問回数をリセット
      this.selected_visit_type = '';
      this.visit_count_active = false;
      this.$store.commit(`${this.state_name}/setSelectedVisitType`, '');

      // ヒートマップデータを再取得
      await this.getScroll();
      await this.getClick();
      await this.getAttention();
    }
  },
  async mounted() {
    await Vue.nextTick();
    this.$store.commit(`${this.state_name}/setDateFrom`, this.date_month_start);
    this.$store.commit(`${this.state_name}/setDateTo`, this.date_to);
  },
  watch: {},
  mixins: [DateformatMixin],
  components: {
    vuejsDatepicker,
    UpgradeUpperMaster,
    SelectVisitCount,
  },
  computed: {
    gradient() {
      return this.$store.getters[`${this.state_name}/gradient`];
    },
    event() {
      return this.$store.state[this.state_name].event_type;
    },
    device() {
      return this.$store.state[this.state_name].device;
    },
    os() {
      return this.$store.state[this.state_name].os;
    },
    placeholder_date_from() {
      return this.$store.state[this.state_name].date_from.replace("00:00:00", "");
    },
    placeholder_date_to() {
      return this.$store.state[this.state_name].date_to.replace("23:59:59", "");
    },
    show_scroll_heatmap() {
      return this.$store.state[this.state_name].show_scroll_heatmap;
    },
    show_click_heatmap() {
      return this.$store.state[this.state_name].show_click_heatmap;
    },
    show_attention_heatmap() {
      return this.$store.state[this.state_name].show_attention_heatmap;
    },
  },
};
</script>
<style lang="scss" scoped>
.parameter-reset-link {
  font-size: 12px;
  color: #6c757d;
  text-decoration: none;

  &:hover {
    color: #495057;
    text-decoration: none;
  }
}
</style>
